<script setup lang="ts">
const { locale } = useI18n()
const { isOpen } = useCollapse()
const runtimeConfig = useRuntimeConfig()
</script>

<template>
  <div class="bg-white px-3 py-2 rounded-full transition-all duration-200">
    <NuxtImg :src="`/img/design-icons/giglogo.png`" class="block m-auto" v-bind="$attrs"
      v-if="runtimeConfig.public.source == 'user'" />
    <NuxtImg :src="`/img/design-icons/logo.svg`" class="block m-auto" v-bind="$attrs" v-else />
  </div>
</template>
